import { openPack } from '../data/pack-store';
import { normalizePackInput } from './resolve';
import { writePackParam } from './url-sync';

/** Single entry point for every way a pack arrives (URL param, typed URL,
 * dropped/picked File). */
export function openPackFromInput(input) {
  if (typeof input === 'string') {
    var url = normalizePackInput(input);
    // Reflect it in ?pack= — the view params (?tab/?test/…) written while
    // browsing would otherwise produce a URL that LOOKS like a deep link
    // but reloads to the picker. File-opened packs have no URL to write;
    // their view params stay session-only by nature.
    writePackParam(url);
    void openPack({
      kind: 'url',
      url: url
    });
  } else {
    void openPack({
      kind: 'file',
      file: input
    });
  }
}